import { endpoint } from './default';

// 取得所有問題
const getQuestionList = () => endpoint.get('/question/all', {
  params: {
    tag: 'CodingWizard',
  },
});

// By Question ID 取得單一問題資訊
const getQuestionById = (qid) => endpoint.get(`/question/${qid}`, {
  params: {
    tag: 'CodingWizard',
  },
});

// 新建問題
const createQuestion = (data) => endpoint.post('/question', data, {
  params: {
    tag: 'CodingWizard',
  },
});

// 更新問題
const updateQuestion = (data, qid) => endpoint.put(`/question/${qid}`, data, {
  params: {
    tag: 'CodingWizard',
  },
});

// 取得單一老師被指定回答的所有問題
const getQuestionByTwId = (tid) => endpoint.get(`/question/teacher/${tid}`, {
  params: {
    tag: 'CodingWizard',
  },
});

// 取得單一學生發問的所有問題
const getQuestionByCwId = (cid) => endpoint.get(`/question/student/${cid}`, {
  params: {
    tag: 'CodingWizard',
  },
});

// 取得單一練習題發問的所有問題
const getQuestionByProblemId = (pid) => endpoint.get(`/question/problem/${pid}`, {
  params: {
    tag: 'CodingWizard',
  },
});

// 取得回復狀態的問題
const getQuestionByReplyStatus = (status) => endpoint.get(`/question/reply_status/${status}`, {
  params: {
    tag: 'CodingWizard',
  },
});

// 刪除問題
const deleteQuestion = (qid) => endpoint.delete(`/question/delete/${qid}`, null, {
  params: {
    tag: 'CodingWizard',
  },
});

// 上傳圖片
const uploadImage = (qid, pid, formData) => endpoint.post(`/image/upload/${qid}/${pid}`, formData, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

// 取得圖片
const getImage = (path) => endpoint.get('/image/download', {
  params: {
    tag: 'CodingWizard',
    path,
  },
  responseType: 'blob',
});

export {
  getQuestionList,
  getQuestionById,
  createQuestion,
  updateQuestion,
  getQuestionByTwId,
  getQuestionByCwId,
  getQuestionByProblemId,
  getQuestionByReplyStatus,
  deleteQuestion,
  uploadImage,
  getImage,
};
